import { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface TradingPaneStateProps {
  eyebrow?: string;
  title: string;
  message: string;
  action?: ReactNode;
  compact?: boolean;
  className?: string;
}

export const TradingPaneState: FC<TradingPaneStateProps> = ({
  eyebrow,
  title,
  message,
  action,
  compact = false,
  className,
}) => (
  <div
    className={cn(
      "flex flex-1 flex-col items-center justify-center text-center",
      compact ? "gap-2 px-5 py-8" : "gap-3 px-6 py-10",
      className,
    )}
  >
    {eyebrow ? (
      <span className="text-[10px] font-medium uppercase tracking-[0.18em] text-sr-pink-muted">
        {eyebrow}
      </span>
    ) : null}
    <div className="space-y-1">
      <h3 className="font-display text-lg font-medium text-white">
        {title}
      </h3>
      <p className="max-w-sm text-sm leading-relaxed text-sr-neutral-500">
        {message}
      </p>
    </div>
    {action ? <div className="pt-1">{action}</div> : null}
  </div>
);
